<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="开通记录"
      id-key="PackageId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @details-opened="onDetailsOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <student-list ref="studentList">
              <template slot="toolbar-right" v-if="!isMB">
                <el-button size="small" class="filter-item" @click="onExport" type="primary" plain>导出</el-button>
              </template>
            </student-list>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button @click="close(true)">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import studentList from './studentList';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    studentList,
  },
  data() {
    return {
      data: {
        PackageId: 0,
      },
      isMB: this.$store.state.isMB,
      api: require("@/api/consume/package").default,
      rules: {
        
      },
    };
  },
  methods: {
    onCreateOpened() {
    },
    onDetailsOpened(data) {
      this.$refs.studentList.getData({ PackageId: data.PackageId });
    },
    onExport() {
      this.$refs.studentList.export();
    },
    onBeforeSave() {

    },
    onClosed() {
      
    },
  }
};
</script>